export default {
  isSearchOpen: false,
  isMiniCartOpen: false,
  previouslyFocusedElement: null,
  headerSearchToggle: null,
  activeVariant: {},
  selectedOptions: [],
  cart: window.BARREL.cart,
  productReviewsLoaded: false,
  hideJen: false,
  modalTarget: null,
  inViewportList: []
}
